import $ from "jquery";

const tooltip = function () {
  const el = $(this);

  el.off("mouseenter");
  el.on("mouseenter", () => positionTooltip(el));

  el.off("mouseleave");
  el.on("mouseleave", () => unPositionTooltip(el));
};

const positionTooltip = (el) => {
  const contentWrapper = el.find(".tooltip__content-wrapper");
  const rect = el.get(0).getBoundingClientRect();

  contentWrapper
    .css({
      left: rect.left,
      top: rect.top,
    })
    .addClass("tooltip__content-wrapper--visible");
};

const unPositionTooltip = (el) => {
  const contentWrapper = el.find(".tooltip__content-wrapper");
  contentWrapper
    .removeAttr("style")
    .removeClass("tooltip__content-wrapper--visible");
};

export const reloadScriptTooltip = () => $(".tooltip").each(tooltip);
reloadScriptTooltip();
